import type { GetFeaturesInnerParams } from '@/app/components/search/components/Card/Details/Features/getFeatures/types.ts';
import { type Feature, FeatureType } from '@/app/components/search/components/Card/utils/facilitiesTypes.ts';

export const getCancellationFeature = ({
  cancellation,
  hideFreeCancellation,
  isHO,
  t,
}: GetFeaturesInnerParams): Feature[] => {
  if (!cancellation || !isHO || hideFreeCancellation) return [];

  return [
    {
      icon: undefined,
      text: t('vacation.oss.components.searchresults.tour_tile.freeCancellation'),
      className: 'cancellation',
      featureType: FeatureType.normal,
    },
  ];
};
